import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {WalletSetting, WalletSticpay} from 'src/app/models/wallet.model';
import {Permission} from 'src/app/models/permission.model';
import {PlatformSettingsService} from '../platform-settings.service';
import {AppService} from 'src/app/app.service';
import {Constants} from 'src/app/shared/utils/constants';

@Component({
  selector: 'fx-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.sass'],
})
export class WalletComponent implements OnInit, OnDestroy {
  @ViewChild('form', { static: false }) form: NgForm;
  @Input() permission: Permission;
  data: WalletSetting = new WalletSetting();
  subscription: any = {};
  constructor(
    private service: PlatformSettingsService,
    private appService: AppService,
  ) {
    this.data = new WalletSetting();
    this.getWalletSettings();
  }

  ngOnInit(): void {}
  getWalletSettings(): void {
    this.subscription.get = this.service
      .getWalletSetting()
      .subscribe((data: any) => {
        if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.data = data.data;
          this.data.sticpay = this.data.sticpay ?? new WalletSticpay();
          this.data.crypto.wdFee =  +((data.data.crypto.wdFee * 100).toFixed(2));
        }
      });
  }

  checkValidate(): Boolean{
    if(this.data.fiat.jpy.minwd >= this.data.fiat.jpy.maxwd ){
      this.appService.showError('Max widthdraw JPY must greater than min widthdraw JPY ');
      return false
    }else if(this.data.fiat.usd.minwd>= this.data.fiat.usd.maxwd){
      this.appService.showError('Max widthdraw USD must greater than min widthdraw USD ');
      return false
    }
    return true
  }

  save(): void {
    if(!this.checkValidate()) return 
    if (this.form.valid) {
      this.appService
        .confirm({
          title: `Are you sure that you want to platform setting?`,
          ok: 'Yes',
          cancel: 'No',
        })
        .subscribe((v: any) => {
          if (v.result) {
            this.data.crypto.wdFee = (this.data.crypto.wdFee / 100);
            this.subscription.update = this.service
              .updateWalletSetting(this.data)
              .subscribe((data: any) => {
                if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
                  this.appService.showSuccess('Update Successful!');
                  this.data.crypto.wdFee = +((this.data.crypto.wdFee * 100).toFixed(2));
                } else {
                  this.appService.showError(data.message || 'Update Failed!');
                }
              });
          }
        });
    } else {
      this.appService.showError('Please enter valid value for platform setting.');
    }
  }

  changeTransactionFeeModeOnClick () {
    this.data.sticpay.transactionFeeMode = this.data.sticpay.transactionFeeMode === 'amount' ? 'ratio' : 'amount';
  }

  ngOnDestroy(): void {
    for (const key of Object.keys(this.subscription)) {
      if (this.subscription.hasOwnProperty(key) && this.subscription[key]) {
        this.subscription[key].unsubscribe();
      }
    }
  }
}
